<template>
  <va-edit-layout :title="title">
    <languages-form :id="id" :title="title" :item="item"></languages-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      questions: this.item.content,
    };
  },
};
</script>
